import React, { useState } from "react";
import { Ticket } from "../../../models/Ticket";
import EAAlert from "../../shared/EAAlert";
import { useTranslation } from "react-i18next";
import EAModal from "../../shared/Modal/EAModal";
import SingleFutureTicketDateSelector from "./Other/SingleFutureTicketDateSelector";
import ChangeTermButton from "../../shared/Buttons/ChangeTermButton";

interface IProps {
  ticket: Ticket;
  onRefreshTickets: () => void;
}

const SingleFutureTicketNoExercise: React.FC<IProps> = ({ ticket, onRefreshTickets }) => {
  const { t } = useTranslation();
  const [openDateSelector, setOpenDateSelector] = useState(false);

  const changeValueOpenDateSelector = () => {
    setOpenDateSelector(!openDateSelector);
  };

  const getAlertMessage = () => {
    return `${t("odwolales_wizyte")}. ${t("aby_wykorzystac_bilet_wybierz_termin")}`;
  };

  const onChangeDateFinish = () => {
    changeValueOpenDateSelector();
    onRefreshTickets();
  };

  return (
    <>
      {" "}
      {ticket.name !== "REZERWACJA" && (
        <div className="single-future-ticket-no-exercise">
          <div className="single-future-ticket-no-exercise__left">
            <EAAlert type="warning" message={""} showOnlyIcon />
            <h5 className="single-future-ticket-details__name">{ticket.name}</h5>
          </div>

          <div className="single-future-ticket-no-exercise__right">
            <EAAlert type="warning" message={getAlertMessage()} />
            <ChangeTermButton
              ticketName={ticket.name}
              onClick={changeValueOpenDateSelector}
              checkIfNotReservation={true}
            />
          </div>

          <EAModal
            isOpen={openDateSelector}
            title={t("wybor_terminu")}
            onClose={changeValueOpenDateSelector}
            hideButtons
          >
            <SingleFutureTicketDateSelector ticket={ticket} onChangeDateFinish={onChangeDateFinish} />
          </EAModal>
        </div>
      )}
    </>
  );
};

export default SingleFutureTicketNoExercise;
